import styled from "styled-components";

export default styled.div`
  &:after {
    content: "* - Required fields";
    font-size: 1.2rem;
    color: #ff5d4c;
    white-space: nowrap;
  }
`;
